import { Grid } from '@mui/material';
import { faker } from '@faker-js/faker';
import { useParams } from 'react-router';
import { Line } from 'react-chartjs-2';

import PageBaseLayout from '../layouts/PageBaseLayout';
import { useEffect, useState } from 'react';
import useSnackbar from '../hooks/useSnackbar';
import useDialog from '../hooks/useDialog';
import useBackdrop from '../hooks/useBackdrop';
import { supabase } from '../supabase-client';
import { calculateBalanceFromTransactions, last30DaysCount } from '../utils';
import StatCard from '../components/StatCard';
import { DataGrid } from '@mui/x-data-grid';

const cardStyle = {
  border: '1px solid grey',
  borderRadius: 2,
  p: 2,
};

export default function CampaignAnalytics() {
  const backdrop = useBackdrop();
  const dialog = useDialog();
  const snackbar = useSnackbar();
  const params = useParams();
  const [affiliateLinksStats, setAffiliateLinksStats] = useState<any[]>([]);

  const getData = async () => {
    backdrop.handleBackdropOpen();

    try {
      //   const balanceResponse = await supabase
      //     .schema('admin_backend')
      //     .from('brand_transactions')
      //     .select('*');

      //   if (balanceResponse.error) {
      //     console.error(
      //       'Error fetching brand transactions:',
      //       balanceResponse.error,
      //     );
      //     throw balanceResponse.error;
      //   }

      //   const balance = calculateBalanceFromTransactions(balanceResponse.data);
      //   setBalance(balance);

      const vouchersResponse = await supabase
        .schema('admin_backend')
        .from('vouchers_admin_view')
        .select('*');

      console.log(vouchersResponse.error);

      const affiliateLinksResponse = await supabase
        .schema('app')
        .from('affiliate_links')
        .select('created_at')
        .eq('campaign_id', Number.parseInt(params.campaignId!));

      if (affiliateLinksResponse.error) {
        console.error(
          'Error fetching affiliate links:',
          affiliateLinksResponse.error,
        );
        throw affiliateLinksResponse.error;
      }

      const affiliateLinks = affiliateLinksResponse.data;
      const data = last30DaysCount(affiliateLinks);
      setAffiliateLinksStats(data);
    } catch (error) {
      snackbar.handleSnackbarOpen('An error occurred.', 'error');
    }

    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PageBaseLayout title={`Campaign: ${params.campaignId}`}>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}>
        <Grid size={4}>
          <StatCard title="Affiliate Links" value="5" interval="" trend="up" />
        </Grid>
        <Grid size={4}>
          <StatCard
            title="Vouchers Generated"
            value="2"
            interval=""
            trend="up"
          />
        </Grid>
        <Grid size={4}>
          <StatCard
            title="Vouchers Redeemed"
            value="0"
            interval=""
            trend="up"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }} sx={cardStyle}>
          <Line
            options={{
              scales: {
                x: {
                  grid: { display: false },
                  type: 'time',
                  time: { unit: 'day', displayFormats: { day: 'yyyy-MM-dd' } },
                },
                y: { grid: { display: false }, ticks: { stepSize: 1 } },
              },
              responsive: true,
              plugins: {
                legend: {
                  display: false,
                  position: 'top' as const,
                },
                title: {
                  display: true,
                  text: 'Affiliate Links Created - Last 30 Days',
                  align: 'start' as const,
                },
              },
            }}
            data={{
              labels: affiliateLinksStats.map((item) => item.date),
              datasets: [
                {
                  label: 'Affiliate Links Created',
                  data: affiliateLinksStats.map((item) => item.count),
                  borderColor: 'rgb(53, 162, 235)',
                  backgroundColor: 'rgba(53, 162, 235, 0.5)',
                },
              ],
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }} sx={cardStyle}>
          <Line
            options={{
              scales: {
                x: {
                  grid: { display: false },
                  type: 'time',
                  time: { unit: 'day', displayFormats: { day: 'yyyy-MM-dd' } },
                },
                y: { grid: { display: false }, ticks: { stepSize: 1 } },
              },
              responsive: true,
              plugins: {
                legend: {
                  display: false,
                  position: 'top' as const,
                },
                title: {
                  display: true,
                  text: 'Vouchers Generated - Last 30 Days',
                  align: 'start' as const,
                },
              },
            }}
            data={{
              labels: affiliateLinksStats.map((item) => item.date),
              datasets: [
                {
                  label: 'Affiliate Links Created',
                  data: affiliateLinksStats.map((item) => item.count),
                  borderColor: 'rgb(53, 162, 235)',
                  backgroundColor: 'rgba(53, 162, 235, 0.5)',
                },
              ],
            }}
          />
        </Grid>
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <SessionsChart />
        </Grid> */}
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <PageViewsBarChart />
        </Grid> */}
      </Grid>
      <DataGrid
        columns={[{ field: 'affiliate', headerName: 'Affiliates', width: 130 }]}
        rows={[
          { id: 1, affiliate: 'Affiliate 1' },
          { id: 2, affiliate: 'Affiliate 2' },
        ]}
        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            // whiteSpace normal to allow wrapping if header text is long
            whiteSpace: 'normal',
            lineHeight: '1.2',
          },
        }}
      />
    </PageBaseLayout>
  );
}
